import { Directive, effect, ElementRef, inject, input, OnDestroy } from '@angular/core';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { FapsStore } from '@app2/store/faps/faps.store';
import { ViewStore } from '@app2/store/view/view.store';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { AdsStore } from '@app2/store/ads/ads.store';
import { FeedTypes } from '@app2/core/models/feed.models';

@Directive({
  selector: '[sensVideo]',
  standalone: true,
  providers: [],
})
export class VideoDirective implements OnDestroy {

  public adsClicked = input<boolean>();

  public adsUrl = input<string>();

  public videoViewed = input.required<boolean>();

  public type = input.required<FeedTypes>();

  public mediaId = input.required<string>();

  public mediaDuration = input<number>();

  private analystService = inject(AnalystService);

  private fapStore = inject(FapsStore);

  private viewStore = inject(ViewStore);

  private adStore = inject(AdsStore);

  private startTime!: number;

  private seconds: number = 0;

  private durationTimer!: any;

  constructor(
    private el: ElementRef,
  ) {
    effect(() => {
      if (this.videoViewed()) {
        this.startTime = Date.now();
        this.startTrack();
      } else {
        if (!!this.seconds) {
          this.stopTrack();
          this.flush();
        }
      }

      if (this.adsClicked()) {
        if (!!this.seconds) {
          this.stopTrack();
          this.adStore.click({ ads_id: this.mediaId(), duration: this.seconds, url: this.adsUrl()! });
        }
      }
    });
  }

  private startTrack() {
    this.durationTimer = setInterval(() => {
      this.seconds = (Date.now() - this.startTime) / 1000;
    }, 100); // Каждые 0.1 секунд
  }

  private stopTrack(): void {
    clearInterval(this.durationTimer);
  }

  private flush(): void {
    let duration = this.seconds;
    this.analystService.logEvent(AnalyticsEventsEnum.MediaView, {
      type: this.type(),
      duration,
      id: this.mediaId(),
    }).then(() => {
      this.seconds = 0;
    });

    if (this.mediaId() !== '0') {
      try {
        if (this.type() === FeedTypes.ADS) {
          this.adStore.view({ ads_id: this.mediaId(), duration: (duration / (this.mediaDuration() || 0)) });
        } else if (this.type().includes('faps')) {
          this.fapStore.trackView({ id: this.mediaId(), duration });
        } else {
          this.viewStore.trackView({ id: this.mediaId(), duration });
        }
      } catch (e) {}
    }

  }

  public ngOnDestroy() {
    if (!!this.seconds) {
      this.stopTrack();
      this.flush();
    }

  }

}
